export default __webpack_public_path__ + "static/media/time.d193ef90.svg";